<template>
    <div class="card">
        <div class="card-header">{{ $t('createShipment.label.Package') }}</div>
        <div class="card-body">
            <b-col sm="12">
                <dangerousGoods :shipment="shipment" :v="v"></dangerousGoods>

                <b-row>
                  <b-col sm="6">
                    <b-form-group
                        label-cols-sm="4"
                        :label="$t('createShipment.label.Pallet')"
                        label-align-sm="left"
                    >
                      <b-input-group size="sm">
                        <b-col sm="10">
                          <b-form-checkbox
                              class="float-left"
                              size="sm"
                              name="shipment.shipmentOptions.hasPallet"
                              v-model="shipment.shipmentOptions.hasPallet"
                          ></b-form-checkbox>
                        </b-col>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                    <b-col sm="6">
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createShipment.label.Not Stackable Pallet')"
                            label-align-sm="left"
                        >
                            <b-input-group size="sm">
                                <b-col sm="10">
                                    <b-form-checkbox
                                        class="float-left"
                                        size="sm"
                                        name="shipment.shipmentOptions.notStackablePallet"
                                        v-model="shipment.shipmentOptions.notStackablePallet"
                                    ></b-form-checkbox>
                                </b-col>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>

                <numberOfPackages :shipment="shipment" :v="v"></numberOfPackages>
                <collis :shipment="shipment" :v="v"></collis>

                <b-row>
                    <b-col sm="6">
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createShipment.label.Total Weight')"
                            label-align-sm="left"
                        >
                            <b-input-group size="sm">
                                <b-col sm="10">
                                    <b-form-input
                                        size="sm"
                                        name="totalWeightInput"
                                        type="number"
                                        v-model.number="totalWeightSum"
                                        :disabled="getIsColliDimension"
                                        min="0"
                                        step="0.01"
                                        :class="{
                                            'is-invalid': v.shipment.colliDetails.totalWeight.$error
                                        }"
                                        aria-describedby="totalWeight-feedback"
                                        @update="v.shipment.colliDetails.totalWeight.$touch()"
                                    />
                                    <validationField
                                        fieldName="createShipment.label.Total Weight"
                                        :validator="v.shipment.colliDetails.totalWeight"
                                        v-if="
                                            !getIsColliDimension &&
                                                v.shipment.colliDetails.totalWeight.$anyDirty
                                        "
                                        name="totalWeightInput.error"
                                    />
                                </b-col>
                                <b-input-group-append>
                                    <div>
                                        <requiredIcon />
                                    </div>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createShipment.label.Total Dryice Weight')"
                            label-align-sm="left"
                            v-if="display(fieldNames.DRY_ICE)"
                        >
                            <b-input-group size="sm">
                                <b-col sm="10">
                                    <b-form-input
                                        size="sm"
                                        name="totalDryIceWeightInput"
                                        type="number"
                                        step="0.01"
                                        v-model.number="totalDryiceWeightSum"
                                        :disabled="true"
                                        :class="{
                                            'is-invalid':
                                                v.shipment.colliDetails.totalDryIceWeight.$error
                                        }"
                                        aria-describedby="totalDryIceWeight-feedback"
                                        @update="v.shipment.colliDetails.totalDryIceWeight.$touch()"
                                    />
                                    <validationField
                                        fieldName="createShipment.label.Total Dryice Weight"
                                        :validator="v.shipment.colliDetails.totalDryIceWeight"
                                        v-if="!getIsColliDimension"
                                        name="totalDryIceWeightInput.error"
                                    />
                                </b-col>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>

                <references :shipment="shipment" :v="v"></references>

                <description :shipment="shipment" :v="v"></description>
            </b-col>
        </div>
    </div>
</template>
<script>
  import vSelect from './vSelect';
  import 'vue-select/dist/vue-select.css';
  import { mapGetters } from 'vuex';
  import viewOptions from '../mixins/viewOptionsMixin';
  import { FIELD_NAMES } from '../store/nameConstants';
  import validationField from './Validation/ValidationField';
  import requiredIcon from './requiredIcon';
  import collis from './collis';
  import dangerousGoods from './dangerousGoods';
  import numberOfPackages from './numberOfPackages';
  import references from './references';
  import description from './description';
  import resetMixin from '../mixins/resetMixin';
  import { ACTIONS, CREATE_SHIPMENT_PREFIX, GETTERS } from '../store/constants';

  export default {
      components: {
          vSelect,
          validationField,
          requiredIcon,
          collis,
          dangerousGoods,
          numberOfPackages,
          references,
          description,
      },
      mixins: [viewOptions, resetMixin],
      props: {
          shipment: { required: true },
          v: { required: true },
      },

      watch: {
          'shipment.shipmentOptions.notStackablePallet': {
              deep: false,
              handler() {
                  if (this.shipment.shipmentOptions.notStackablePallet) {
                      this.shipment.shipmentOptions.hasPallet = true;
                  }
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                  );
              },
          },
        'shipment.shipmentOptions.hasPallet': {
          deep: false,
          handler() {
            this.$store.dispatch(
                CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
            );
          },
        },

          'shipment.colliDetails.totalWeight': {
              handler() {
                  this.clearCommodities();
              },
          },
      },
      data() {
          return {
              fieldNames: FIELD_NAMES,
          };
      },
      mounted() {
          this.shipment.colliDetails = { numberOfColli: 1, totalWeight: 0, totalDryIceWeight: 0 };
          this.shipment.shipmentOptions.hasPallet = false;
      },
      methods: {
          clearCommodities() {
              if (
                  this.shipment.customsAmount.commodities &&
                  this.shipment.customsAmount.commodities.length > 0
              ) {
                  this.shipment.customsAmount.commodities = [];
              }
          },
      },
      computed: {
          ...mapGetters('createShipment', ['getIsColliDimension']),

          totalWeightSum: {
              get() {
                  if (this.shipment.collis != null && this.getIsColliDimension) {
                      const r = this.shipment.collis.reduce((prev, cur) => {
                          return prev + Number(cur.weight);
                      }, 0);
                      if (r != undefined) {
                          this.shipment.colliDetails.totalWeight = r;
                      }

                      return r;
                  }
                  return this.shipment.colliDetails.totalWeight;
              },
              set(value) {
                  this.shipment.colliDetails.totalWeight = value;
                  var singleColliWeight = value / this.shipment.collis.length;
                  this.shipment.collis.forEach((c) => {
                      c.weight = singleColliWeight;
                  });
              },
          },

          totalDryiceWeightSum: {
              get() {
                  if (this.shipment.collis != null && this.getIsColliDimension) {
                      const r = this.shipment.collis.reduce((prev, cur) => {
                          return prev + Number(cur.dryIce);
                      }, 0);

                      this.shipment.colliDetails.totalDryIceWeight = r;

                      return r;
                  }
                  return this.shipment.colliDetails.totalDryIceWeight;
              },
              set(value) {
                  this.shipment.colliDetails.totalDryIceWeight = value;
              },
          },
      },
  };
</script>
<style>
  .input-group-sm > .input-group-append > .input-group-text {
      font-size: 10px;
      height: 25px;
  }

  .input-group-sm > .form-control:not(textarea) {
      height: 25px;
  }
</style>
